import { createStepRegistry } from "../../utils/flowAnalytics/createStepRegistry.js";
import { normalizeEntryFlowSlug, normalizeFlowSlug } from "../../utils/flowAnalytics/flowSlug.js";
import GeneralError from "../../searchFlowVersionB/steps/common/GeneralError.jsx";
import KftRegActivityDescription from "../steps/KftRegActivityDescription.jsx";
import KftRegContactPage from "../steps/KftRegContactPage.jsx";
import KftRegForeignTrade from "../steps/KftRegForeignTrade.jsx";
import KftRegIndustryActivity from "../steps/KftRegIndustryActivity.jsx";
import KftRegIndustrySelect from "../steps/KftRegIndustrySelect.jsx";
import KftRegSuccessScreen from "../steps/KftRegSuccessScreen.jsx";
import KftRegTaxForm from "../steps/KftRegTaxForm.jsx";

/**
 * Stable step metadata keyed by React component.
 * stepId values are persisted in MongoDB — do not rename; add new entries for new steps.
 */
const STEP_META_BY_COMPONENT = new Map([
  [KftRegIndustrySelect, { id: "kftreg_industry_select", phase: "kftreg" }],
  [KftRegIndustryActivity, { id: "kftreg_industry_activity", phase: "kftreg" }],
  [KftRegActivityDescription, { id: "kftreg_activity_description", phase: "kftreg" }],
  [KftRegTaxForm, { id: "kftreg_tax_form", phase: "kftreg" }],
  [KftRegForeignTrade, { id: "kftreg_foreign_trade", phase: "kftreg" }],
  [KftRegContactPage, { id: "kftreg_contact_page", phase: "kftreg" }],
  [KftRegSuccessScreen, { id: "kftreg_success_screen", phase: "kftreg" }],
  [GeneralError, { id: "kftreg_general_error", phase: "kftreg" }],
]);

/**
 * Context fields owned by each step — only these are sent on events for that step.
 * Persisted in MongoDB; add keys here when a step collects new analytics dimensions.
 */
export const STEP_CONTEXT_FIELDS = {
  kftreg_industry_select: ["industry", "companytype"],
  kftreg_industry_activity: ["industry", "companytype"],
};

const kftRegFlowStepRegistry = createStepRegistry({
  metaByComponent: STEP_META_BY_COMPONENT,
  contextFieldsByStepId: STEP_CONTEXT_FIELDS,
});

export const { getStepMeta, getStepMetaAtIndex, getStepContextFieldKeys } =
  kftRegFlowStepRegistry;

export default kftRegFlowStepRegistry;

export { normalizeEntryFlowSlug, normalizeFlowSlug };
